import React from "react";
import { NavLink } from "react-router-dom";

const VisualEffectsList = ({ filmId, sceneId, visualEffects }) => {
  return (
    <aside className="menu">
      <p className="menu-label">Visual Effects in scene</p>
      <ul className="menu-list">
        {(visualEffects || []).map((visualEffect, idx) => {
          return (
            <li key={idx}>
              <NavLink
                to={`/films/${filmId}/visual-effects/${visualEffect.id}/edit`}
                activeClassName="is-active"
              >
                {visualEffect.name}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

export default VisualEffectsList;
